import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const getValidationSchema = (t: TFunction, prefix: string, noEmail: boolean) => {
    if (noEmail)
        return Yup.object().shape({
            customerMail: Yup.string()
                .trim()
                .email(t(`${prefix}.validation.email.mustBeEmail`))
                .required(t(`${prefix}.validation.email.required`)),
            newPaymentDay: Yup.number().required(),
        });

    return Yup.object().shape({
        newPaymentDay: Yup.number().required(),
    });
};
